import React, { useRef, useState, useEffect } from "react";
import CssTransition from "../../../../component/layout/css-transition";
import InputField from "../../../../component/input-field";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { getAllDepartmentByCompanyId } from "../../../../redux/actions/todo";
import { getUsersByDepartmentId } from "../../../../redux/actions/todo";
import { getCollaboratorOrCustomer } from "../../../../redux/actions/collaboratorOrCustomer";
import { deleteUser } from "../../../../redux/actions/user";
import {
  Collaborator,
  Customer,
} from "../../../../constant/AuthenticationConstant";
import { useFormik } from "formik";
import * as Yup from "yup";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../../../component/modal-popup/customeModal";
import { deleteCollaboratorOrCustomer } from "../../../../redux/actions/collaboratorOrCustomer";

export default function DeleteUser({
  type,
  openDeleteModal,
  setOpenDeleteModal,
  update,
  setUpdate,
  setUserId,
  userId,
}) {
  const modalContent = useRef(null);
  const dispatch = useDispatch();

  const [allTeamsOptions, setAllTeamsOptions] = useState();
  const [user_or_collaborator_options, setUser_or_collaborator_options] =
    useState();

  const [responsibleTeamValue, setResponsibleTeamValue] = useState();
  const [responsibleUserValue, setResponsibleUserValue] = useState();

  const validationSchema = Yup.object().shape({
    team_id: Yup.string().required("This field is required."),
    user_id: Yup.string().required("This field is required."),
    delete_text: Yup.string()
      .required("This field is required.")
      .matches(/Delete/, "Invalid text."),
  });

  const handleDelete = () => {
    const deletePayload = {};
    if (
      formik.values.team_id !== Collaborator &&
      formik.values.team_id !== Customer
    ) {
      deletePayload.user_id = formik.values.user_id;
      deletePayload.department_id = formik.values.team_id;
      deletePayload.collaborator_id = null;
    } else {
      deletePayload.user_id = null;
      deletePayload.department_id = null;
      deletePayload.collaborator_id = formik.values.user_id;
    }
    const request = {
      payload: deletePayload,
      id: userId,
      onSuccess: () => {
        formik.resetForm();
        setUpdate(update + 1);
        setOpenDeleteModal(false);
        setUserId();
        setResponsibleTeamValue();
        setResponsibleUserValue();
      },
      onError: (error) => {
        formik.resetForm();
        setOpenDeleteModal(false)
        setUserId()
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={
                error?.message
                  ? error?.message
                  : "Something went wrong. Please try again later."
              }
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };

    if(type === "Customer" || type === "Collaborator") {
      dispatch(deleteCollaboratorOrCustomer(request))
    } else {
      dispatch(deleteUser(request))
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      team_id: "",
      user_id: "",
      delete_text: "",
    },
    validationSchema,
    onSubmit: () => {
      handleDelete();
    },
  });

  // API calling to get team list
  const teamList = () => {
    dispatch(
      getAllDepartmentByCompanyId((res) => {
        if (res.status === 1) {
          const result = res.data;
          const teamsArray = result.map((team) => {
            return { value: team.id, label: team.name, name: "department" };
          });
          let departmentOptions = [
            {
              label: "Collaborator",
              value: Collaborator,
            },
            {
              label: "Customer",
              value: Customer,
            },
            {
              label: "Internal Teams",
              options: teamsArray,
            },
          ];
          setAllTeamsOptions(departmentOptions);
        }
      })
    );
  };

  // API calling to get Collaborator and Customer list
  const collaboratorList = () => {
    dispatch(
      getCollaboratorOrCustomer(responsibleTeamValue.value, (res) => {
        if (res.status === 1) {
          const users = res.data.map((item) => {
            return {
              value: item.collaborator_id,
              label: item.name,
              name: "user",
            };
          });
          setUser_or_collaborator_options(users);
        }
      })
    );
  };

  // API calling to get User list
  const getUserList = () => {
    dispatch(
      getUsersByDepartmentId(responsibleTeamValue?.value, (res) => {
        if (res.status === 1) {
          const users = res.data.map((item) => {
            return { value: item.id, label: item.name, name: "user" };
          });
          setUser_or_collaborator_options(users);
        }
      })
    );
  };

  useEffect(() => {
    if (openDeleteModal) {
      teamList();
    }
  }, [openDeleteModal]);

  useEffect(() => {
    if (responsibleTeamValue && responsibleTeamValue?.name) {
      getUserList();
    } else if (
      responsibleTeamValue &&
      (responsibleTeamValue.value === Collaborator ||
        responsibleTeamValue.value === Customer)
    ) {
      collaboratorList();
    } else {
      setUser_or_collaborator_options([]);
    }
  }, [responsibleTeamValue]);

  return (
    <>
      <CssTransition
        className="fixed inset-0 bg-slate-900 bg-opacity-30 z-50 transition-opacity"
        show={openDeleteModal}
        enter="transition ease-out duration-200"
        enterStart="opacity-0"
        enterEnd="opacity-100"
        leave="transition ease-out duration-100"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
        aria-hidden="true"
      />
      <CssTransition
        id="delete"
        className="fixed inset-0 z-50 overflow-hidden flex items-center my-4 justify-center px-4 sm:px-6"
        role="dialog"
        aria-modal="true"
        show={openDeleteModal}
        enter="transition ease-in-out duration-200"
        enterStart="opacity-0 translate-y-4"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-in-out duration-200"
        leaveStart="opacity-100 translate-y-0"
        leaveEnd="opacity-0 translate-y-4"
      >
        <div
          ref={modalContent}
          className="bg-white rounded-xl shadow-lg overflow-auto max-w-[478px] w-full max-h-full"
        >
          <div className="p-7">
            <div
              className={`mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-rose-100`}
            >
              <span className="far fa-exclamation-triangle fill-current text-3xl text-rose-400"></span>
            </div>
            <div className="mt-3 text-center sm:mt-5">
              <h3 className="text-base font-semibold leading-6 text-gray-900">
                Are you sure?
              </h3>
              <div className="mt-2">
                <div className="text-sm text-gray-500">
                  All of your data will be permanently removed from our servers
                  forever. This action cannot be undone.
                </div>
              </div>
            </div>
            <div className="mt-5 space-y-2">
              <div>
                <label for="country" class="block mb-1 text-sm font-medium">
                  Responsible Team&nbsp;
                  <span className="text-rose-500">*</span>
                </label>
                <Select
                  options={allTeamsOptions}
                  isClearable={true}
                  menuPortalTarget={document.body}
                  className="basic-single text-sm unresetText"
                  classNames={{
                    control: (style) => {
                      return `!border !shadow-sm ${
                        style.isFocused
                          ? "!border-[--bg-color-300]/50"
                          : "!border-slate-200 hover:!border-gray-300"
                      }`;
                    },
                    container: (style) => {
                      return "!h-[37.5px] !font-inter !text-sm";
                    },
                    menuList: (style) => {
                      return `!max-h-[200px]`;
                    },
                  }}
                  name="team_id"
                  value={responsibleTeamValue}
                  onChange={(team) => {
                    setResponsibleUserValue(null);
                    setResponsibleTeamValue(team);
                    formik.setFieldValue("team_id", team?.value);
                    formik.setFieldValue("user_id", "");
                  }}
                  styles={{
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                    placeholder: (provided, state) => ({
                      ...provided,
                      color: "#9B9B9B", // Set your desired color here
                      fontSize: "14px",
                    }),
                  }}
                  placeholder="Select Team"
                  menuPlacement="auto"
                />
                {Boolean(formik.touched.team_id && formik.errors.team_id) ? (
                  <p className="text-xs text-rose-500 text-left">
                    {`${formik.errors.team_id}!`}
                  </p>
                ) : null}
              </div>
              <div>
                <label for="country" class="block mb-1 text-sm font-medium">
                  Responsible User&nbsp;
                  <span className="text-rose-500">*</span>
                </label>
                <Select
                  name="user_id"
                  options={user_or_collaborator_options}
                  isClearable={true}
                  menuPortalTarget={document.body}
                  className="basic-single text-sm unresetText"
                  styles={{
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                    placeholder: (provided, state) => ({
                      ...provided,
                      color: "#9B9B9B", // Set your desired color here
                      fontSize: "14px",
                    }),
                  }}
                  placeholder="Select User"
                  menuPlacement="top"
                  value={responsibleUserValue}
                  onChange={(user) => {
                    setResponsibleUserValue(user);
                    formik.setFieldValue("user_id", user?.value);
                  }}
                  required
                />
                {Boolean(formik.touched.user_id && formik.errors.user_id) ? (
                  <p className="text-xs text-rose-500 text-left">
                    {`${formik.errors.user_id}!`}
                  </p>
                ) : null}
              </div>
              <InputField
                type="text"
                label={`Type "Delete" to delete this user`}
                name="delete_text"
                onBlur={formik.handleBlur}
                error={
                  Boolean(
                    formik.touched.delete_text && formik.errors.delete_text
                  )
                    ? formik.errors.delete_text
                    : null
                }
                value={formik.values.delete_text}
                onChange={(e) =>
                  formik.setFieldValue("delete_text", e.target.value)
                }
                required
              />
            </div>
            <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
              <button
                type="button"
                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-slate-900 shadow-sm ring-1 ring-inset ring-slate-200 hover:ring-gray-300 sm:col-start-1 sm:mt-0 custom-cancel-button"
                onClick={() => {
                  formik.resetForm();
                  setOpenDeleteModal(false);
                  setResponsibleUserValue(null);
                  setResponsibleTeamValue(null);
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                className="inline-flex w-full justify-center rounded-md !bg-rose-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:!bg-rose-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-rose-600 sm:col-start-2 custome-delete-button"
                onClick={() => {
                  // setOpenDeleteModal(false)
                  formik.handleSubmit();
                }}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </CssTransition>
    </>
  );
}
